import ApplicationAdapter from 'lumen/adapters/application';

export default class HighlightAdapter extends ApplicationAdapter {
  buildURL(): string {
    return `${this.host}/apigateway/v1/app/highlights/`;
  }
}
